// import { BrowserRouter } from 'react-router-dom';
// import { Provider } from 'react-redux';
// import { store } from './store/store';
// import AppRoutes from './routes/AppRoutes';
// import { ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import './App.css';

// function App() {
//   return (
//     <Provider store={store}>
//       <BrowserRouter>
//         <AppRoutes />
//         <ToastContainer position="top-right" autoClose={3000} closeOnClick pauseOnHover />
//       </BrowserRouter>
//     </Provider>
//   );
// }

// export default App;
import { BrowserRouter, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { Provider } from 'react-redux';
import { store } from './store/store';
import AppRoutes from './routes/AppRoutes';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);
  return null;
};

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <ScrollToTop />
        <AppRoutes />
        <ToastContainer position="top-right" autoClose={3000} closeOnClick pauseOnHover />
      </BrowserRouter>
    </Provider>
  );
}

export default App;
